import w from "./index.es474.js";
import s from "./index.es520.js";
import d from "./index.es519.js";
import h from "./index.es533.js";
function y(r, t) {
  return S(r) || E(r, t) || g(r, t) || b();
}
function b() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function g(r, t) {
  if (r) {
    if (typeof r == "string") return m(r, t);
    var e = {}.toString.call(r).slice(8, -1);
    return e === "Object" && r.constructor && (e = r.constructor.name), e === "Map" || e === "Set" ? Array.from(r) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? m(r, t) : void 0;
  }
}
function m(r, t) {
  (t == null || t > r.length) && (t = r.length);
  for (var e = 0, n = Array(t); e < t; e++) n[e] = r[e];
  return n;
}
function E(r, t) {
  var e = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (e != null) {
    var n, o, l, a, u = [], c = !0, i = !1;
    try {
      if (l = (e = e.call(r)).next, t !== 0) for (; !(c = (n = l.call(e)).done) && (u.push(n.value), u.length !== t); c = !0) ;
    } catch (f) {
      i = !0, o = f;
    } finally {
      try {
        if (!c && e.return != null && (a = e.return(), Object(a) !== a)) return;
      } finally {
        if (i) throw o;
      }
    }
    return u;
  }
}
function S(r) {
  if (Array.isArray(r)) return r;
}
function k(r, t, e, n, o, l) {
  if (e === null && !o)
    return "";
  var a = {
    r: d(t, r)
  };
  if (o && (a.s = o), e === null)
    return "<c".concat(s(a), "/>");
  if (n === Date && !o)
    throw new Error('No "format" has been specified for a Date cell');
  var u = I(n, e, l), c = x(n);
  c && (a.t = c);
  var i = D(n), f = y(i, 2), p = f[0], v = f[1];
  return "<c".concat(s(a), ">") + p + u + v + "</c>";
}
function x(r) {
  switch (r) {
    case String:
      return "s";
    // I don't know why did I comment out the use of "inlineStr" XLSX type.
    // Perhaps there were some issues with it. Or perhaps there weren't and everyone else just uses "s".
    // // "inlineStr" type is used instead of "s" to avoid creating a "shared strings" index.
    // return 'inlineStr'
    case Number:
      return;
    case Date:
      return;
    case Boolean:
      return "b";
    case "Formula":
      return;
    default:
      throw new Error("Unknown schema type: ".concat(r && r.name || r));
  }
}
function I(r, t, e) {
  switch (r) {
    case String:
      if (typeof t != "string")
        throw new Error("Invalid cell value: ".concat(t, ". Expected a string"));
      return e(t);
    case Number:
      if (typeof t != "number")
        throw new Error("Invalid cell value: ".concat(t, ". Expected a number"));
      return String(t);
    case Date:
      if (!(t instanceof Date))
        throw new Error("Invalid cell value: ".concat(t, ". Expected a Date"));
      return String(h(t));
    case Boolean:
      if (typeof t != "boolean")
        throw new Error("Invalid cell value: ".concat(t, ". Expected a boolean"));
      return t ? "1" : "0";
    case "Formula":
      if (typeof t != "string")
        throw new Error("Invalid cell value: ".concat(t, ". Expected a string"));
      return w(t);
    default:
      throw new Error("Unknown schema type: ".concat(r && r.name || r));
  }
}
var A = /</g;
function D(r) {
  var t = N(r), e = t.replace(A, "</");
  return [t, e];
}
function N(r) {
  switch (r) {
    // case 'inlineStr':
    //   return '<is><t>'
    case "Formula":
      return "<f>";
    default:
      return "<v>";
  }
}
export {
  k as default
};
//# sourceMappingURL=index.es530.js.map
